import { render, staticRenderFns } from "./ArticleListPrev.vue?vue&type=template&id=39716b95&scoped=true&"
import script from "./ArticleListPrev.vue?vue&type=script&lang=ts&"
export * from "./ArticleListPrev.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleListPrev.vue?vue&type=style&index=0&id=39716b95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39716b95",
  null
  
)

export default component.exports